<template>
  <div class="container">
    <div style="margin-bottom: 12px">
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
        >导出</el-button
      >
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleSet">
      <el-form size="mini" :model="searchInfo" label-width="90px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="员工名称:" prop="name">
              <el-input
                v-model="searchInfo.name"
                placeholder="请输入"
                @change="handleSearch"
                clearable
                prefix-icon="el-icon-search"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工资所属月:" prop="month_date">
              <el-date-picker
                clearable
                v-model="searchInfo.month_date"
                type="monthrange"
                value-format="yyyy-MM"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                @change="handleSearch"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合计工资:">
              <div class="inputBox">
                <el-input
                  v-model.number="searchInfo.amount_start"
                  type="number"
                  placeholder="最低数值"
                  @change="handleSearch"
                ></el-input>
                <span>至</span>
                <el-input
                  v-model.number="searchInfo.amount_end"
                  type="number"
                  placeholder="最高数值"
                  @change="handleSearch"
                >
                </el-input>
                <span
                  class="el-icon-circle-close clear-icon cu-po"
                  v-if="searchInfo.amount_start && searchInfo.amount_end"
                  @click="
                    () => {
                      searchInfo.amount_start = '';
                      searchInfo.amount_end = '';
                      handleSearch();
                    }
                  "
                ></span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="是否授课老师:" prop="status">
              <el-radio-group
                v-model="searchInfo.status"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">是</el-radio-button>
                <el-radio-button :label="2">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      ref="mainTable"
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="序号" prop="num"></el-table-column>
      <el-table-column label="工资所属月" prop="belong_month"></el-table-column>
      <el-table-column label="员工名称" prop="staff.name"></el-table-column>
      <el-table-column label="员工手机号" prop="staff" min-width="130">
        <template slot-scope="scope">
          {{ "+" + scope.row.staff.area_code }}
          {{ scope.row.staff.mobile }}
        </template>
      </el-table-column>
      <el-table-column label="是否授课老师" prop="is_teach" min-width="130">
        <template slot-scope="scope">
          <div>{{ scope.row.is_teach === 1 ? "是" : "否" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="item in customTableData"
        :key="item.salary_item_id"
        :label="item.name"
        min-width="130"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.item_list.length > 0">
            {{
              scope.row.item_list
                .filter((it) => {
                  if (item.salary_item_id === it.item_id) {
                    return it.amount;
                  }
                })
                .map((i) => {
                  if (i.amount && i.amount.substr(-3) === ".00") {
                    i.amount = i.amount.slice(0, i.amount.length - 3);
                  }
                  return i.amount;
                })
                .join("") || "-"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合计工资" prop="amount" min-width="130">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.amount.substr(-3) === ".00"
                ? scope.row.amount.slice(0, scope.row.amount.length - 3)
                : scope.row.amount
            }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="amount">
      <p>合计</p>
      <p v-for="item in customTableData" :key="item.salary_item_id">
        {{ item.name }}：
        <span>
          {{
            item.type === 2 && item.totalAmount >= 0
              ? "-" + item.totalAmount.toFixed(2)
              : item.totalAmount.toFixed(2)
          }}
        </span>
      </p>
      <p>
        合计工资: <span>{{ Number(tableTotal).toFixed(2) }}</span>
      </p>
    </div>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>

<script>
import {
  salaryOrderStaffListApi,
  salaryOrderStaffListExportApi,
} from "@/api/salary";
import { exportLoop } from "@/utils/export";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  components: { commonSearchFormWrapper },
  props: ["visible"],
  data() {
    return {
      searchInfo: {
        name: "",
        month_date: [],
        status: -1,
        amount_start: "",
        amount_end: "",
      },
      tableData: [],
      customTableData: [],
      tableTotal: 0, // 表格合计列的总和
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      pickerOptions: {
        disabledDate(time) {
          const year = new Date().getFullYear(); //获取当前年份
          const month = new Date().getMonth() + 1; //获取当前月份
          const tot = new Date(year + "-" + month + "-1").getTime(); //获取当前年月转成时间戳
          return time.getTime() > tot;
        },
      },
    };
  },
  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleSet() {
      this.searchInfo = {
        name: "",
        month_date: [],
        status: -1,
        amount_start: "",
        amount_end: "",
      };
      this.handleSearch();
    },
    getList(val) {
      const params = {
        page: val.page,
        page_size: val.page_size,
      };
      if (this.searchInfo.name) {
        params.key_word = this.searchInfo.name;
      }
      if (this.searchInfo.month_date && this.searchInfo.month_date.length > 0) {
        params.belong_month_start_date = this.searchInfo.month_date[0];
        params.belong_month_end_date = this.searchInfo.month_date[1];
      }
      if (this.searchInfo.amount_start !== "" && !this.searchInfo.amount_end) {
        this.$message({
          type: "warning",
          message: "请填写最高数值",
        });
        return false;
      }
      if (this.searchInfo.amount_start === "" && this.searchInfo.amount_end) {
        this.searchInfo.amount_start = "0";
      }
      if (this.searchInfo.amount_start && this.searchInfo.amount_end) {
        if (
          Number(this.searchInfo.amount_end) <
          Number(this.searchInfo.amount_start)
        ) {
          this.$message({
            type: "warning",
            message: "最高数值须高于最低数值",
          });
          return false;
        }
        params.amount_start = String(this.searchInfo.amount_start);
        params.amount_end = String(this.searchInfo.amount_end);
      }
      if (this.searchInfo.status > -1) {
        params.is_teach = this.searchInfo.status;
      }
      salaryOrderStaffListApi(params).then((res) => {
        if (res.error_code === 0) {
          // 处理合计的数组
          const totalArr = [];
          this.tableTotal = 0;
          if (res.data.list && res.data.list.list.length > 0) {
            let num = 1;
            res.data.list.list.map((item) => {
              item.num = num++;
              this.tableTotal += Number(item.amount);
              item.item_list.map((it) => {
                it.amount = it.item_type === 1 ? it.amount : "-" + it.amount;
                totalArr.push(it);
              });
            });
          }
          this.tableData = res.data.list.list;
          this.total = res.data.list.total;
          if (res.data.field && res.data.field.length > 0) {
            res.data.field.map((item) => {
              if (item.name === "基本工资") {
                item.name = item.name + "（元）";
              }
              item.totalAmount = 0;
              totalArr.map((it) => {
                if (item.salary_item_id === it.item_id) {
                  item.totalAmount += Number(it.amount);
                }
              });
            });
          }
          this.customTableData = res.data.field;
        }
      });
    },
    handleExport() {
      const params = {};
      if (this.searchInfo.name) {
        params.key_word = this.searchInfo.name;
      }
      if (this.searchInfo.month_date && this.searchInfo.month_date.length > 0) {
        params.belong_month_start_date = this.searchInfo.month_date[0];
        params.belong_month_end_date = this.searchInfo.month_date[1];
      }
      if (this.searchInfo.amount_start && this.searchInfo.amount_end) {
        params.amount_start = this.searchInfo.amount_start;
        params.amount_end = this.searchInfo.amount_end;
      }
      if (this.searchInfo.status > -1) {
        params.is_teach = this.searchInfo.status;
      }
      salaryOrderStaffListExportApi(params).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        }
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  .inputBox {
    display: flex;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 30px;
    height: 30px !important;
    position: relative;
    .el-input {
      width: 165px;
    }
    /deep/.el-input__inner {
      border: none !important;
    }
    span {
      margin: 0 10px 0 0;
    }
    &:hover {
      .clear-icon {
        display: block;
      }
    }
    .clear-icon {
      position: absolute;
      top: 8px;
      right: 0;
      font-size: 14px;
      color: #d8d8d8;
      cursor: pointer;
      display: none;
    }
    .el-input {
      width: auto;
      text-align: center;
    }
  }
  .amount {
    background-color: #f8f8f8;
    padding: 0 10px;
    overflow: auto hidden;
    white-space: nowrap;
    &::-webkit-scrollbar {
      width: 4px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      width: 4px;
      background: none;
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      background: #c1c1c1;
      border-radius: 4px;
    }
    p {
      display: inline-block;
      vertical-align: center;
      font-size: 12px;
      line-height: 16px;
      color: #5c5d5e;
      margin-right: 10px;
      padding: 17px 0;
      span {
        color: #07d1aa !important;
      }
    }
  }
}
/deep/ .el-range-editor {
  height: 30px !important;
  line-height: 30px !important;
}
</style>
